import {Component, Input, OnInit} from '@angular/core';
import {RequestExecutor} from '../../util/request-executor';

@Component({
    selector: 'app-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.css'],
    standalone: false
})
export class AttachmentComponent implements OnInit {
  _id: string;
  key: string;

  @Input()
  get id() {
    return this._id;
  }

  set id(val) {
    this._id = val;
    this.key = 'i_' + this._id.replace(/-/g, '',);
    this.load();
  }

  data: any = {};
  loading = false;

  constructor(private request: RequestExecutor) {
  }

  ngOnInit(): void {
  }

  private load() {
    if (this.data[this.key] == null) {
      this.loading = true;

      this.request.get('/attachment', {attachmentId: this.id})
        .then((response: any) => {
          this.data[this.key] = response.Base64Image;
        })
        .finally(() => this.loading = false);
    }
  }
}
